import { useAnalyticsPageTracking } from '../utils/useAnalyticsPageTracking';

export default function AnalyticsPageTracker() {
  useAnalyticsPageTracking();
  return null;
}
